import { v4 as uuidV4, v5 as uuidV5 } from "uuid";

import type { UUID } from "../types/index.ts";

export function deterministicUuid({
  namespace,
  value,
}: {
  readonly namespace: UUID;
  readonly value: string;
}): string {
  return uuidV5(value, namespace);
}

export function uuid(): string {
  return uuidV4();
}
